import { Button } from '@components/button';
import { Text } from '@components/text';
import { useToaster } from '@components/toaster';

import { useMarkAllAsRead } from 'api/notifications/hooks';
import { Modal, ModalProps } from 'features/modals';
import { useStore } from 'models/Provider';

type Props = ModalProps<{
  latestId: number;
}>;

export const MarkAllAsReadModal = (props: Props) => {
  const { t } = useStore();
  const { showError, showSuccess } = useToaster();
  const markAllAsRead = useMarkAllAsRead(props.latestId, {
    onSuccess: () => {
      props.closeModal();
      showSuccess(t('notifications.modals.markasread.success'));
    },
    onError: () => {
      showError(t('notifications.modals.markasread.error'));
    },
  });
  const submit = () => {
    markAllAsRead.mutate();
  };

  return (
    <Modal>
      <Modal.Header text={t('notifications.modals.markasread.header')} />
      <Text text={t('notifications.modals.markasread.text')} />
      <Modal.Actions>
        <Button
          variant="secondary"
          onClick={props.closeModal}
          isDisabled={markAllAsRead.isLoading}
          text={t('common.forms.button.cancel')}
        />
        <Button
          variant="primary"
          onClick={submit}
          isDisabled={markAllAsRead.isLoading}
          text={t('common.forms.button.submit')}
        />
      </Modal.Actions>
    </Modal>
  );
};
